import React, {useContext, useEffect} from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import logo from "../../assets/img/logo_white.png";
import {Link as LinkRouter, NavLink, useLocation} from "react-router-dom";
import {refSections} from "../../App";
import CustomizedAccordions from "../Elements/Accordion";
import ro_ro from "../../assets/img/bethesda/ro_RO.png";
import de_de from "../../assets/img/bethesda/de_DE.png";

export default function Sidebar({ sidebarOpen, toggleSidebar, handleNavLinks }) {

  const location = useLocation();
  const { refSectionsList, setRefSectionsList } = useContext(refSections);
    let localStorageLanguage = localStorage.getItem("language");
    const isRO = localStorageLanguage === "ro";

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          {
            location.pathname === "/" ?
                <Link onClick={() => toggleSidebar(!sidebarOpen)} activeClass={"active"} className="whiteColor" style={{ borderBottom: "none" }} to="home" spy={true} offset={-60}>
                  <LinkRouter className="whiteColor" to={"/"}><img src={logo} alt={logo} width={"161px"} height={"51px"}/></LinkRouter>
                </Link>
                :<LinkRouter
                    onClick={() => {toggleSidebar(!sidebarOpen); if (location.pathname !== "/") { refSectionsList.sectionToScroll = "home" }}}
                    className="whiteColor"
                    style={{ padding: "10px 15px" }}
                    to={`/${localStorage.getItem("language") ? localStorage.getItem("language") : ''}`}>
                  <img src={logo} alt={logo} width={"161px"} height={"51px"}/>
                </LinkRouter>
          }
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font16 pointer">
          {
            location.pathname === "/" ?
                <Link onClick={() => toggleSidebar(!sidebarOpen)} activeClass={"active"} className="whiteColor" style={{ padding: "10px 15px" }} to="home" spy={true} offset={-60}>
                  <LinkRouter className="whiteColor" to={"/"}>{isRO ? "Acasă" : "Startseite"}</LinkRouter>
                </Link>
                :<LinkRouter
                    onClick={() => {toggleSidebar(!sidebarOpen); if (location.pathname !== "/") { refSectionsList.sectionToScroll = "home" }}}
                    className="whiteColor"
                    style={{ padding: "10px 15px" }}
                    to={`/${localStorage.getItem("language") ? localStorage.getItem("language") : ''}`}>
                  {isRO ? "Acasă" : "Startseite"}
                </LinkRouter>
          }
        </li>
        <li className="semiBold font16 pointer">
          {
            location.pathname === "/" ?
                <Link onClick={() => toggleSidebar(!sidebarOpen)} activeClass="active" className="whiteColor" to="despre-noi"
                      spy={true} offset={-60}
                      style={{padding: "10px 15px"}}
                >
                  <LinkRouter className="whiteColor" to={"/"}>
                    {isRO ? "Despre noi" : "Über uns"}
                  </LinkRouter>
                </Link>
                : <LinkRouter
                    onClick={() => {toggleSidebar(!sidebarOpen); if (location.pathname !== "/") { refSectionsList.sectionToScroll = "despre-noi" }}}
                    className="whiteColor" to={"/"}
                    style={{padding: "10px 15px"}}>{isRO ? "Despre noi" : "Über uns"}
                </LinkRouter>
          }
        </li>
        {/*<li className="semiBold font16 pointer">*/}
                {/*// <Link onClick={() => toggleSidebar(!sidebarOpen)} activeClass={"active"} className="whiteColor" style={{ padding: "10px 15px" }}*/}
                {/*//       to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/resurse' : 'ressourcen'}`}*/}
                {/*//       spy={true} offset={-60}>*/}
                {/*//   <LinkRouter className="whiteColor" to={"/"}>{isRO ? "Resurse" : "Ressourcen"}</LinkRouter>*/}
                {/*// </Link>*/}
        {/*        <LinkRouter*/}
        {/*            onClick={() => {toggleSidebar(!sidebarOpen);}}*/}
        {/*            className="whiteColor"*/}
        {/*            style={{ padding: "10px 15px" }}*/}
        {/*            to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/resurse' : 'ressourcen'}`}*/}
        {/*        >*/}
        {/*          {isRO ? "Resurse" : "Ressourcen"}*/}
        {/*        </LinkRouter>*/}
        {/*</li>*/}

        <CustomizedAccordions
          title={
            <li className="semiBold font16 pointer">
              <LinkRouter className="whiteColor"
                          // to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/resurse' : 'ressourcen'}`}
                  to={""}
              >
                {isRO ? "Resurse" : "Ressourcen"}
              </LinkRouter>
            </li>
          }
          content={
            <div className={'d-flex justify-content-center align-items-center text-white flex-column'}>
              <NavLink onClick={() => toggleSidebar(!sidebarOpen)} className={'px-2 py-3 whiteColor'} to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/predici' : 'predigten'}`}>{isRO ? "Predici" : "Predigten"}</NavLink>
              <NavLink onClick={() => toggleSidebar(!sidebarOpen)} className={'px-2 py-3 whiteColor'} to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/cantari' : 'lieder'}`}>{isRO ? "Cantari" : "Lieder"}</NavLink>
              <NavLink onClick={() => toggleSidebar(!sidebarOpen)} className={'px-2 py-3 whiteColor'} to={`/${localStorage.getItem("language") ? localStorage.getItem("language") + '/poezii' : 'gedichte'}`}>{isRO ? "Poezii" : "Gedichte"}</NavLink>
            </div>
          }/>

        <li className="semiBold font16 pointer">
          {
            location.pathname === "/" ?
                <Link onClick={() => toggleSidebar(!sidebarOpen)} activeClass={"active"} className="whiteColor" style={{padding: "10px 15px"}}
                      to="contact" spy={true} offset={-60}>
                  <LinkRouter className="whiteColor" to={"/"}>
                    {isRO ? "Contact" : "Kontakt"}
                  </LinkRouter>
                </Link>
                : <LinkRouter
                    onClick={() => {toggleSidebar(!sidebarOpen); if (location.pathname !== "/") refSectionsList.sectionToScroll = "contact"}}
                    className="whiteColor" style={{padding: "10px 15px"}} to="/">
                  {isRO ? "Contact" : "Kontakt"}
                </LinkRouter>
          }
        </li>

        <CustomizedAccordions
            title={
              <li className="semiBold font16 pointer">
                <LinkRouter className="whiteColor"  to={'/'}>
                  {
                    localStorage.getItem("language") === "ro" ?  (
                        <div>
                          <img style={{marginRight: "10px"}} src={ro_ro} alt={ro_ro} width={"18px"} height={"12px"}/>
                          RO
                        </div>
                    ) : (
                        <div>
                          <img style={{marginRight: "10px"}} src={de_de} alt={de_de} width={"18px"} height={"12px"}/>
                          DE
                        </div>
                    )
                  }
                </LinkRouter>
              </li>
            }
            content={
              <div className={'d-flex justify-content-center align-items-center text-white flex-column'}>
                <div className={'px-2 py-3'} onClick={()=>{window.location = "/"}}>
                  <img style={{marginRight: "10px"}} src={de_de} alt={de_de} width={"18px"} height={"12px"}/>
                  DE
                </div>
                <div className={'px-2 py-3'} onClick={()=>{window.location = "/ro"}}>
                  <img style={{marginRight: "10px"}} src={ro_ro} alt={ro_ro} width={"18px"} height={"12px"}/>
                  RO
                </div>
              </div>
            }/>
      </UlStyle>
      {/*<UlStyle className="flexSpaceCenter">*/}

        {/*<li className="semiBold font16 pointer">*/}
        {/*  <a href="/" style={{ padding: "10px 30px 10px 0" }} className="whiteColor">*/}
        {/*    Log in*/}
        {/*  </a>*/}
        {/*</li>*/}
        {/*<li className="semiBold font16 pointer flexCenter">*/}
        {/*  <a href="/" className="radius8 lightBg" style={{ padding: "10px 15px" }}>*/}
        {/*    Get Started*/}
        {/*  </a>*/}
        {/*</li>*/}
      {/*</UlStyle>*/}
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;
